export default __webpack_public_path__ + "static/media/Background 5_00042.16b5c16e.png";